  <!-- CONTENUTO -->
  <div class="container mb-5">
    <div class="row">
      <div class="col-12">
          <div class="error-template">
              <h1>
                  Oops!</h1>
              <h2 [innerHTML]="'404_INTESTAZIONE' | translate | htmlToText | safe"></h2>
              <div class="error-details" [innerHTML]="'404_TESTO_PAGINA' | translate | htmlToText | safe"></div>
              <div class="error-actions">
                  <a [appHref]="'/'" ><button class="btn btn-stem btn-lg">Home </button></a>
                  <a [appHref]="'/'" ><button class="btn btn-stem btn-alt btn-lg">Contatta il supporto </button></a>
              </div>
          </div>
      </div>
    </div>
  </div>